<template>
  <div>
    <LoadingSpinner v-if="$apollo.loading" />
    <div v-else-if="article">
      <h1 v-if="!titleInContent">
        {{ article.title }}
        <button
          style="margin-right: 10px; float: right"
          @click.stop="$emit('select-article-uri', null)"
          title="Close article"
        >
          x
        </button>
      </h1>
      <button
        v-else
        style="margin-top: 0.5em; margin-right: 10px; float: right"
        @click.stop="$emit('select-article-uri', null)"
        title="Close article"
      >
        x
      </button>

      <div class="content" v-if="content" v-html="content" />

      <button
        v-if="hasMore"
        @click.stop="$emit('select-article-uri', null)"
        title="Show all articles for current selection"
      >
        Show all articles
      </button>
    </div>
  </div>
</template>
<script>
  import { marked } from 'marked';
  import gql from 'graphql-tag';
  import mixins from '@/mixins';
  import LoadingSpinner from '@/symphony/widgets/components/LoadingSpinner.vue';

  export default {
    name: 'ArticleDetail',
    components: {
      LoadingSpinner,
    },
    mixins: [mixins.LocalizationMixin],
    props: {
      articleUri: {
        type: String,
      },
      hasMore: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['select-article-uri'],
    computed: {
      article() {
        if (!this.articles || this.articles.length === 0) {
          return null;
        }
        const articleData = this.articles[0];
        return {
          uri: articleData.uri,
          title: this.getLocalizedOrFallback(articleData, 'title'),
          description: this.getLocalizedOrFallback(articleData, 'description'),
          collection: articleData.collection,
        };
      },
      content() {
        if (!this.article) {
          return null;
        }
        const { description } = this.article;
        return description ? marked.parse(description) : null;
      },
      titleInContent() {
        return this.content ? this.content.startsWith('<h1>') : false;
      },
    },
    apollo: {
      articles: {
        query: gql`
          query ArticleDetail($uri: String!, $language: String = "eng") {
            articles(filters: { uri: { exact: $uri } }, pagination: { limit: 1, offset: 0 }) {
              id
              uri
              collection {
                uri
                label
              }
              title(language: $language)
              description(language: $language)
              localizations {
                language
                title
                description
              }
            }
          }
        `,
        variables() {
          return {
            uri: this.articleUri,
            language: this.lang,
          };
        },
        skip() {
          return !this.articleUri;
        },
        update(data) {
          return data.articles;
        },
      },
    },
  };
</script>

<style scoped lang="scss">
  a {
    user-select: none;
    cursor: pointer;
    color: unset;
    &:hover {
      color: #4d4ddd;
    }
  }
</style>
